export default __webpack_public_path__ + "media/zurb/img/work/design-insight-674a21289980c525614abf414304661e.svg";